<template>
    <router-view />
</template>

<script>
    export default {
        name: "mobileLayout"
    }
</script>

<style scoped>

</style>
